import styled from "styled-components";

const NestedPageLayoutWrapper = styled.section<{ height?: string }>`
	height: ${({ height }) => `calc(100%  - ${height ?? "149px"})`};
	overflow-y: auto;
	padding-right: 20px;
	overflow-x: hidden;
	margin-right: -20px;
	width: calc(100% + 20px);
`;

export { NestedPageLayoutWrapper };
